export default "__VITE_ASSET__3fa4721f__"